"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mercogliano": {
    "4bd5de5d": [{
      "hkey": "97fbf2f8",
      "slug": "mercogliano",
      "name": "Mercogliano",
      "primary": true,
      "skipSearch": false
    }],
    "acqua-delle-noci": [{
      "hkey": "97fbf2f8",
      "slug": "mercogliano",
      "name": "Mercogliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "77281796": [{
      "hkey": "97fbf2f8",
      "slug": "mercogliano",
      "name": "Mercogliano",
      "primary": true,
      "skipSearch": false
    }],
    "badia-loreto": [{
      "hkey": "97fbf2f8",
      "slug": "mercogliano",
      "name": "Mercogliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e36e97e0": [{
      "hkey": "cd4c1fd7",
      "slug": "torelli-torrette",
      "name": "Torelli-Torrette",
      "primary": true,
      "skipSearch": false
    }],
    "torelli": [{
      "hkey": "cd4c1fd7",
      "slug": "torelli-torrette",
      "name": "Torelli-Torrette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mercogliano"
    }],
    "dfd09215": [{
      "hkey": "cd4c1fd7",
      "slug": "torelli-torrette",
      "name": "Torelli-Torrette",
      "primary": true,
      "skipSearch": false
    }],
    "torrette": [{
      "hkey": "cd4c1fd7",
      "slug": "torelli-torrette",
      "name": "Torelli-Torrette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mercogliano"
    }]
  }
};
exports["default"] = _default;